// GWurfData.js
export const GWurfData = {
    Dunkel: {
        label: 'Dunkel',
        data: [
            0.388,  // 1
            0.435,  // 2
            0.492,  // 3
            0.556,  // 4
            0.639,  // 5
            0.700,  // 6
            0.767,  // 7
        ],
        borderColor: 'rgba(105, 105, 105, 1)',
        backgroundColor: 'rgba(105, 105, 105, 0.2)',
        sex: 'female'
    },
    Rüde: {
        label: 'Rüde',
        data: [
            0.469,  // 1
            0.530,  // 2
            0.624,  // 3
            0.690,  // 4
            0.760,  // 5
            0.834,  // 6
            0.909,  // 7
        ],
        borderColor: 'rgba(0, 0, 139, 1)',
        backgroundColor: 'rgba(0, 0, 139, 0.2)',
        sex: 'male'
    },
    Braun: {
        label: 'Braun',
        data: [
            0.480,  // 1
            0.530,  // 2
            0.603,  // 3
            0.710,  // 4
            0.800,  // 5
            0.860,  // 6
            0.970,  // 7
        ],
        borderColor: 'rgba(139, 69, 19, 1)',
        backgroundColor: 'rgba(139, 69, 19, 0.2)',
        sex: 'female'
    },
    Silber: {
        label: 'Silber',
        data: [
            0.440,  // 1
            0.490,  // 2
            0.567,  // 3
            0.652,  // 4
            0.731,  // 5
            0.821,  // 6
            0.890,  // 7
        ],
        borderColor: 'rgba(192, 192, 192, 1)',
        backgroundColor: 'rgba(192, 192, 192, 0.2)',
        sex: 'female'
    }
};

export const milestones = [];